import React from 'react';
import { useTranslation } from 'react-i18next';
import { StarIcon } from '../../../../shared/Icons';
import CardLayout from '../../../../shared/components/card/CardLayout';
import { Button } from 'react-bootstrap';

export function UserAndRolesBasicPack() {
    const { t } = useTranslation();
    return (
        <CardLayout classBody="text-center">
            <StarIcon width="100" height="100" />
            <h5 className="my-3">{t('brand.package.info_about_feature')}</h5>
            <Button onClick={() => (window.location.href = String(process.env.VITE_REFILL_TOKEN_CALENDLY))}>
                {t('general.button.contact/support')}
            </Button>
        </CardLayout>
    );
}
